import locationApi from '@/apis/location';

export const GET_ZONES = 'getZones';

export const actions = {
  async [GET_ZONES]() {
    return await locationApi.getZones();
  },
};
